import { IRaffleDefaultTicketDTO } from "@hooks/dtos/raffles/IRaffleDefaultDTO";
import { Masks } from "@hooks/functions/Masks/Masks";

const masks = new Masks();

export function NumericTicketLabel({ ticket }: { ticket: IRaffleDefaultTicketDTO }) {
  const number = Number(ticket.ticket);
  return <strong>{Number.isFinite(number) ? `${number < 10 ? "0" : ""}${masks.formatMilhar(number)}` : ticket.ticket}</strong>;
}

export function NamedTicketLabel({ ticket }: { ticket: IRaffleDefaultTicketDTO }) {
  return <><strong>{ticket.ticket}</strong><small>Nº {masks.formatMilhar(ticket.order)}</small></>;
}
